import { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './SlideShow.module.css';
import { BASE_URL_IMG, getData } from '~/helper/apiService';

const cx = classNames.bind(styles);

function SlideShow() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [posts, setPosts] = useState([]); // Thay slides tĩnh bằng posts động
  const [isLoading, setIsLoading] = useState(true); // Để handle loading nếu cần

  // Hàm loadPosts (đã sửa để luôn load 10 posts, như yêu cầu trước)
  const loadPosts = async () => {

    const params = new URLSearchParams();

      params.append('limit', 17);

    try {
      const newPosts = await getData(`/post/read?${params.toString()}`);
      setPosts(newPosts); // Giả sử newPosts là array {image, title, description}
    } catch (error) {
      console.error('Error loading posts:', error);
    }
  };

  // Load posts khi component mount
  useEffect(() => {
    loadPosts(); // Load không limit ban đầu
    setIsLoading(false);
  }, []);

  // Auto slide effect (chỉ chạy nếu có posts)
  useEffect(() => {
    if (posts.length === 0) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % posts.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [posts.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrev = () => {
    setCurrentSlide((prev) => (prev - 1 + posts.length) % posts.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % posts.length);
  };

  // Nếu đang loading hoặc chưa có posts, hiển thị placeholder
  if (isLoading || posts.length === 0) {
    return (
      <div className={cx('wrapper')}>
        <div className={cx('slideshow')}>
          <p>Loading slides...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={cx('wrapper')}>
      <div className={cx('slideshow')}>
        {posts.map((post, index) => (
          <div
            key={index}
            className={cx('slide', { active: index === currentSlide })}
          >
            <img src={BASE_URL_IMG + '/' + post.img} alt={post.title} className={cx('image')} />
            <div className={cx('content')}>
              <h2 className={cx('title')}>{post.title}</h2>
              {/* <p className={cx('description')}>{post.description}</p> */}
            </div>
          </div>
        ))}
        
        <button className={cx('prev')} onClick={goToPrev}>
          &#10094;
        </button>
        <button className={cx('next')} onClick={goToNext}>
          &#10095;
        </button>

        <div className={cx('dots')}>
          {posts.map((_, index) => (
            <span
              key={index}
              className={cx('dot', { active: index === currentSlide })}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SlideShow;